<template>
  <div class="seventhPage">
    <div class="head">
      <img src="/static/imgs/secondPage/sun.png" />
      <span class="back">ABOUT US</span>
      <span class="front">关于我们</span>
    </div>
    <el-row class="content">
      <span><a href="/Wiki" target="_blank">X Learning（无界学习）</a>是国内首家将沉浸式学习理论应用于企业组织发展领域的专业培训与咨询机构。作为一家致力于在学习发展领域突破创新的成长型公司，我们的愿景是 ”让改变可见！
        “，我们一直怀着极大的热情关注并参与互联网新经济下的人才发展，团队发展、组织发展，我们通过持续的产品创新，与客户共创，不断为各行各业提供耳目一新的沉浸式学习产品与服务，为客户企业的组织发展赋能。
      </span>
    </el-row>
    <el-row class="content">
      <span>自2015年起，X
        Learning陆续开发出十几门沉浸式学习品牌课程，并创造性地将沉浸式学习技术融入到团队工作坊与学习发展项目实践，为230+家企业提供了沉浸式培训与咨询服务，服务地区覆盖京津、长三角、珠三角以及华中核心经济区的一二线城市，服务行业包括制药、医疗器械、互联网、教育、能源、电商、旅游、汽车、物流、投资、银行、保险、快速消费品、工业品、零售、运动等众多行业，为超过30,000名学习者提供了独特的沉浸式学习。
      </span>
    </el-row>
    <el-row class="xuanchuan" :gutter="8">
      <el-col class="box" :span="8">
        <span class="title">使命：</span>
        <span class="info">成为一家健康的自驱型专业Learning Company
          基于沉浸式学习方法论，提供沉浸式学习产品与服务，为客户组织发展赋能</span>
      </el-col>
      <el-col class="box" :span="8">
        <span class="title">愿景：</span>
        <span class="info">让改变可见！</span>
      </el-col>
      <el-col class="box" :span="8">
        <span class="title">价值观：</span>
        <div class="tags">
          <el-row :gutter="20" class="row">
            <el-col :span="12">
              <span class="tag">做事到位</span>
            </el-col>
            <el-col :span="12">
              <span class="tag">做人真诚</span>
            </el-col>
          </el-row>
          <el-row :gutter="20" class="row">
            <el-col :span="12">
              <span class="tag">自我驱动</span>
            </el-col>
            <el-col :span="12">
              <span class="tag">接纳包容</span>
            </el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "seventhPage",
  data () {
    return {};
  },
  mounted () { },
  methods: {},
};
</script>
<style lang="less" scoped>
.seventhPage {
  margin: 0 0 0 0;
  background-color: whitesmoke;
  padding: 140px 0;
}

.head {
  text-align: center;

  img {
    margin-left: -130px;
  }
  .back {
    position: absolute;
    font-size: 55px;
    color: cornflowerblue;
    margin-left: -90px;
    margin-top: -10px;
    z-index: 0;
    opacity: 0.2;
  }
  .front {
    position: absolute;
    font-size: 45px;
    margin-top: 22px;
    margin-left: -65px;
    margin-top: 10px;
    letter-spacing: 8px;
  }
}
.content {
  padding: 14px 100px;
  text-align: left;
  color: #001f57;
}
.xuanchuan {
  margin-top: 50px;
  padding: 0 30px;

  .box {
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: center;
    .title {
      width: 80px;
      height: 30px;
      background-color: #cbdcfb;
      font-weight: bold;
      text-align: center;
      line-height: 30px;
    }
    .info {
      margin-top: 40px;
      text-align: left;
    }
    .tags {
      margin-top: 40px;
      .row {
        padding-bottom: 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/seventhPage.vue